<div class="flex lg:flex-row flex-col gap-8 justify-center" *ngIf="!add">

    <!-- BOX -->
    <div class="md:w-1/4 w-full flex flex-col gap-4 justify-center">
        <p class="text-center font-medium mb-0">Box</p>
        <img #image_box [src]="spettacolo && spettacolo.img_box ? (spettacolo.img_box + '?type=spettacolo' | image) : (img_box.length > 0 ? img_box : '../../../../../assets/images/Noimage.png')" (error)="image_box.src='../../../../../assets/images/Noimage.png'" class="w-full h-full object-cover border">
        <button type="button" class="btn-outln-backoffice p-[0.50rem]" (click)="onCarica('box')">Carica foto box</button>
    </div>
    <!-- BOX -->
    <!-- HOME -->
    <div class="md:w-1/4 w-full flex flex-col gap-4 justify-center">
        <p class="text-center font-medium mb-0">Home</p>
        <img #image_home [src]="spettacolo && spettacolo.img_home ? (spettacolo.img_home + '?type=spettacolo' | image) : (img_home.length > 0 ? img_home : '../../../../../assets/images/Noimage.png')" (error)="image_home.src='../../../../../assets/images/Noimage.png'" class="w-full h-full object-cover border">
        <button type="button" class="btn-outln-backoffice p-[0.50rem]" (click)="onCarica('home')">Carica foto home</button>
    </div>
    <!-- HOME -->
    <!-- COVER -->
    <div class="md:w-1/4 w-full flex flex-col gap-4 justify-center">
        <p class="text-center font-medium mb-0">Copertina</p>
        <img #image_cover [src]="spettacolo && spettacolo.img_copertina ? (spettacolo.img_copertina + '?type=spettacolo' | image) : (img_cover.length > 0 ? img_cover : '../../../../../assets/images/Noimage.png')" (error)="image_cover.src='../../../../../assets/images/Noimage.png'" class="w-full h-full object-cover border">
        <button type="button" class="btn-outln-backoffice p-[0.50rem]" (click)="onCarica('cover')">Carica foto copertina</button>
    </div>
    <!-- COVER -->

</div>

<!-- BOX -->
<ng-container *ngIf="add && tipo == 'box'">
    <app-image-cropper [type]="'box'" [aspect_ratio]="1/1" [height]="700" [width]="700" [accept]="'image/*'" (onCrop)="onRitaglio($event)"></app-image-cropper>
    <div class="flex lg:flex-row flex-col gap-4 w-full justify-center mt-12">
        <button type="button" class="w-1/4 btn-outln-backoffice p-[0.50rem]" (click)="onConferma()">Ritaglia</button>
        <button type="button" class="w-1/4 btn-danger-backoffice p-[0.50rem]" (click)="add=false;">Annulla</button>
    </div>
</ng-container>
<!-- BOX -->

<!-- HOME -->
<ng-container *ngIf="add && tipo == 'home'">
    <app-image-cropper [aspect_ratio]="970/770" [height]="970" [width]="770" accept="image/*" (onCrop)="onRitaglio($event)"></app-image-cropper>

    <div class="flex lg:flex-row flex-col gap-4 w-full justify-center mt-12">
        <button type="button" class="w-1/4 btn-outln-backoffice p-[0.50rem]" (click)="onConferma()">Ritaglia</button>
        <button type="button" class="w-1/4 btn-danger-backoffice p-[0.50rem]" (click)="add=false;">Annulla</button>
    </div>
</ng-container>
<!-- HOME -->

<!-- COVER -->
<ng-container *ngIf="add && tipo == 'cover'">
    <app-image-cropper [type]="'cover'" [aspect_ratio]="1900/870" [height]="870" [width]="1900" [accept]="'image/*'" (onCrop)="onRitaglio($event)"></app-image-cropper>
    <div class="flex lg:flex-row flex-col gap-4 w-full justify-center mt-12">
        <button type="button" class="w-1/4 btn-outln-backoffice p-[0.50rem]" (click)="onConferma()">Ritaglia</button>
        <button type="button" class="w-1/4 btn-danger-backoffice p-[0.50rem]" (click)="add=false;">Annulla</button>
    </div>
</ng-container>
<!-- COVER -->